@if (order$ | async; as order) {
  <app-efa-order-overview [order]="order"></app-efa-order-overview>
}
